var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValmetLogoNegative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "2507px",
    height: "896px",
    viewBox: "0 0 2507 896",
    enableBackground: "new 0 0 2507 896",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "2507,895.7 0,895.7 0,0 2507,0  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2569.8267,
    y1: -1084.7709,
    x2: 2680.6836,
    y2: -1195.6278,
    gradientTransform: "matrix(0.7969 0 0 -0.7969 52.7035 -351.0555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0881031,
    style: {
      stopColor: "#389249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1906,
    style: {
      stopColor: "#3B984C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    style: {
      stopColor: "#47AF58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9863,
    style: {
      stopColor: "#4CB75C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M2157.6,454.4l-204.1,204.1l45,45c43.1,43.1,86.2,0,86.2,0l249.1-249.1H2157.6L2157.6,454.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 2570.0317,
    y1: -1078.6343,
    x2: 2680.8887,
    y2: -1189.4912,
    gradientTransform: "matrix(0.7969 0 0 0.7969 52.7035 1242.0018)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#389249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#40A251"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6187,
    style: {
      stopColor: "#49B159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    style: {
      stopColor: "#4CB75C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M2334,441.4l-249.1-249.1c0,0-43.1-43.1-86.2,0l-45,45l204.2,204.2L2334,441.4L2334,441.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1421.4,442.3H1330c4.6-33.4,14.9-44.2,47.7-44.2C1408.5,398.1,1420.3,405.7,1421.4,442.3 M1372.1,338.5 c-75.5,0-123.8,31.3-123.8,137.1c0,107.9,54.9,140.1,128.9,140.1c29.8,0,68.8-5.7,95-14.4l-11.8-60c-19.5,5.1-53.8,8.7-72.9,8.7 c-38,0-56.9-7.7-57.9-49.7h160.7C1497.4,365.2,1459.5,338.5,1372.1,338.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M355.5,497.8c-15.1-57.4-55.4-181.8-78.2-244.7c-2-5.6-9.1-15.3-18.1-15.3H173v3.8c0,0,16.8,2.1,28.9,38.9 c24.6,74.6,83,258.2,102.8,328.1h97c34.4-83.7,97.2-287.1,121.9-370.8h-87.1C418.6,298.3,376.6,437.7,355.5,497.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M812.3,237.8h-79.1v296.3c0,93.3,91.2,79.4,91.2,79.4c-10.6-21.4-12.1-56.2-12.1-81.5V237.8L812.3,237.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M921.2,413.4c10.3-3.1,23.1-4.6,34.4-4.6c36,0,43.7,12.8,43.7,60.5v139.1h78.6V463.3 c0-19.5-2.1-36-5.1-49.7c12.8-3.1,29.8-4.6,39.6-4.6c36,0,43.7,12.8,43.7,60.5v139.1h78.6V463.3c0-94.5-32.4-124.8-105.3-124.8 c-29.8,0-63.2,7.2-90.9,17c-15.9-11.8-38-17-65.8-17c-47.2,0-96.6,11.3-130.5,23.6v246.5h79.1L921.2,413.4L921.2,413.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1702.1,413.4v-67.8h-82.2v-44.3c0-39.5,5.3-63.6,5.3-63.6s-84.5,11-84.5,68.8v39h-42.6v67.8h42.6v106.5 c0,78.6,32.4,96.1,90.4,96.1c28.3,0,59.5-5.1,79.1-13.4l-12.7-60.6c-12.3,4.1-25.7,7.2-42.1,7.2c-27.7,0-35.4-10.8-35.4-37.5v-98.1 L1702.1,413.4L1702.1,413.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M634.2,550.1c-12.3,4.6-28.8,7.2-43.7,7.2c-30.8,0-37.5-4.6-37.5-31.3c0-26.2,10.3-29.3,38.5-29.3 c15.9,0,30.8,0.5,42.6,3.6L634.2,550.1L634.2,550.1z M709.2,595.3V440.7c0-78.1-37-102.2-115.6-102.2c-39,0-49.3,1.4-79.7,9.1 l-22.5,67c22.1-6.7,52.8-12,83.2-12c51.3,0,59.5,10.3,59.5,46.6c-20-4.1-40.1-6.7-59.5-6.7c-62.6,0-102.7,11.8-102.7,85.8 c0,68.8,25.7,87.3,112.5,87.3C622.9,615.8,673.6,608.1,709.2,595.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 2510.2856,
    y1: -872.7638,
    x2: 2250.7173,
    y2: -1132.3323,
    gradientTransform: "matrix(0.7969 0 0 -0.7969 52.7035 -351.0555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77787B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#626366"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    fill: "url(#SVGID_4_)",
    d: "M1749.4,454.4l200.3,200.3l88.2-88.2l-112.1-112.1H1749.4L1749.4,454.4z  M1949.8,241.1l-200.4,200.3h176.3l112.2-112.2L1949.8,241.1z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValmetLogoNegative);
export default __webpack_public_path__ + "static/media/valmet-logo-negative.8555269f461d0519c588ea6469e1f615.svg";
export { ForwardRef as ReactComponent };